<div class="d-flex justify-content-between align-items-center w-100 ">
  <h2 mat-dialog-title>
    {{ roleName }}
  </h2>
  <div class="p-x-15">
    <button matTooltip="Close" mat-icon-button color="info" class="mobile-hidden" (click)="closeDialog()">
      <i-tabler name="X"></i-tabler>
    </button>
  </div>
</div>

<mat-dialog-content>
  <div class="table-responsive-sm">
    <mat-table #table [dataSource]="paginatedData">
      <ng-container matColumnDef="code">
        <mat-header-cell *matHeaderCellDef class="f-w-600 mat-subtitle-1 f-s-14 p-x-24 p-l-0">
            {{ "RoleManagement.AuthorizationCodes" | localize }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="p-x-24 f-s-14 p-l-0">
          <mat-checkbox
            [(ngModel)]="element.selected"
            (change)="toggleAuthorizationCode(element.codeId, element.selected)"
          ></mat-checkbox>
          {{ element.code }}
        </mat-cell>

      </ng-container>
      <ng-container matColumnDef="description">
        <mat-header-cell *matHeaderCellDef class="f-w-600 mat-subtitle-1 f-s-14 p-x-24 p-l-0">
            {{ "RoleManagement.Description" | localize }}
        </mat-header-cell>
        <mat-cell *matCellDef="let element">
          {{ element.description }}
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      <tr class="mat-row" *matNoDataRow style="justify-content: center !important; display: flex;">
        <td colspan="5" *ngIf="isDataLoading" class="d-flex flex-col align-items-center justify-content-center">
          <mat-spinner diameter="40"></mat-spinner>
          <p>{{"RoleManagement.CodesLoading" | localize}}</p>
        </td>
        <td *ngIf="!isDataLoading" class="mat-cell" [attr.colspan]="displayedColumns.length" style="text-align: center;">
            {{"RoleManagement.NoCode" | localize}}
        </td>
      </tr>
    </mat-table>
    <mat-paginator 
      *ngIf="totalElements > 0" 
      [pageSize]="pageSize" 
      [length]="totalElements" 
      [pageIndex]="currentPage" 
      [pageSizeOptions]="[10, 20, 50]" 
      (page)="onPageChange($event)">
    </mat-paginator>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="closeDialog()">{{"RoleManagement.Cancel" | localize}}</button>
  <button mat-button cdkFocusInitial (click)="saveAuthorizationCodes()">{{"RoleManagement.Save" | localize}}</button>
</mat-dialog-actions>
